import { makeApiCall } from "../makeApiCall";
import { CustomerService_URL } from "../Url";

export const newPasswordActions = {
  NEW_PASSWORD_SUCCESS: "NEW_PASSWORD_SUCCESS",
  NEW_PASSWORD_ERROR: "NEW_PASSWORD_ERROR",
};

export function newPasswordSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: newPasswordActions.NEW_PASSWORD_SUCCESS,
      payload: props,
    });
  };
}

export function newPasswordError(error) {
  return {
    type: newPasswordActions.NEW_PASSWORD_ERROR,
    payload: error,
  };
}

export function newPasswordThunk(accessToken, oldPassword, newPassword) {
  const reqHeader = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + accessToken,
  };
  const getUrl = `${CustomerService_URL}/changePassword?currentPassword=${oldPassword}&newPassword=${newPassword}`;
  return makeApiCall(
    getUrl,
    newPasswordSuccess,
    newPasswordError,
    "POST",
    null,
    reqHeader
  );
}
